// extracted by mini-css-extract-plugin
module.exports = {"root":"section-header_root__cUd7t","heading":"section-header_heading__QzfcM","category":"section-header_category__qOFfI"};